const DEFAULT_API_HOSTS = ["api.matters3.feradel.com", "api.auth.feradel.com"];

function allowedHosts(extraHosts = []) {
  const configured = String(process.env.REACT_APP_ALLOWED_TENANT_HOSTS || "")
    .split(",")
    .map(value => value.trim().toLowerCase().replace(/\.$/, ""))
    .filter(Boolean);
  return new Set([...DEFAULT_API_HOSTS, ...configured, ...extraHosts]);
}

export function safeApiRoot(value, { allowLocalhost = process.env.NODE_ENV !== "production", extraHosts = [] } = {}) {
  const raw = String(value || "").trim().replace(/^['"]+|['";]+$/g, "").trim();
  if (!raw) return "/";
  if (raw.startsWith("/")) return raw.endsWith("/") ? raw : `${raw}/`;
  try {
    const localAuthority = /^(localhost|127\.0\.0\.1)(?::|\/|$)/i.test(raw);
    const url = /^https?:\/\//i.test(raw)
      ? new URL(raw)
      : new URL(`${localAuthority ? "http" : "https"}://${raw}`);
    const hostname = url.hostname.toLowerCase().replace(/\.$/, "");
    const local = allowLocalhost && (hostname === "localhost" || hostname === "127.0.0.1");
    if ((!local && url.protocol !== "https:") || (local && !["http:", "https:"].includes(url.protocol))) return null;
    if (url.username || url.password || (!local && url.port && url.port !== "443")) return null;
    if (!local && !allowedHosts(extraHosts).has(hostname)) return null;
    const path = url.pathname.replace(/\/+$/, "");
    return `${url.origin}${path}/`;
  } catch (_error) {
    return null;
  }
}
